import React from 'react'
import ReactDOM from 'react-dom/client'
import 'react-resizable/css/styles.css'
import './index.css'
import App from './App'
// V2.7

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
